import { useCallback, useState } from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { adminApi } from '../../../lib/admin-api/index.js';
import { ALL_SECTIONS } from '../constants.js';

export function useRestoreSettings() {
  const { token } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [file, setFile] = useState(null);
  const [password, setPassword] = useState('');
  const [strategy, setStrategy] = useState('overwrite');
  const [sections, setSections] = useState(ALL_SECTIONS.map((s) => s.value));
  const [confirmOpen, setConfirmOpen] = useState(false);

  const openConfirm = useCallback(() => setConfirmOpen(true), []);
  const closeConfirm = useCallback(() => setConfirmOpen(false), []);

  const toggleSection = useCallback((value) => {
    setSections((prev) =>
      prev.includes(value) ? prev.filter((s) => s !== value) : [...prev, value],
    );
  }, []);

  const restore = useCallback(async () => {
    if (!file || !password || sections.length === 0) return;
    setIsLoading(true);
    setError('');
    setSuccess('');
    setConfirmOpen(false);
    try {
      await adminApi.restoreSettings(token, { file, password, strategy, sections });
      setSuccess('Settings restored successfully.');
      setFile(null);
      setPassword('');
    } catch (err) {
      setError(err?.message || 'Restore failed.');
    } finally {
      setIsLoading(false);
    }
  }, [token, file, password, strategy, sections]);

  return {
    file,
    setFile,
    password,
    setPassword,
    strategy,
    setStrategy,
    sections,
    toggleSection,
    confirmOpen,
    openConfirm,
    closeConfirm,
    restore,
    isLoading,
    error,
    success,
  };
}
